import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseSignalRService } from './base-signalr.service';

@Injectable({
  providedIn: 'root'
})
export class OpportunityRevisitsSignalRService extends BaseSignalRService {
  private readonly opportunityUpdatedSubject = new BehaviorSubject<string>('');

  public opportunityUpdated$ = this.opportunityUpdatedSubject.asObservable();

  protected getHubUrl(): string {
    return `${this.configService.callCenterApiUrl}/opportunityRevisitsHub`;
  }

  protected setupEventHandlers(): void {
    if (!this.hubConnection) return;

    this.hubConnection.on('OpportunityUpdated', (opportunityId: string) => {
      this.opportunityUpdatedSubject.next(opportunityId);
    });

    this.hubConnection.on('OpportunityRevisit', (opportunityId: string) => {
      this.opportunityUpdatedSubject.next(opportunityId);
    });

    this.setupConnectionStateHandlers();
  }
}
